import { GQL_ID } from '@@partner:types:graphql'

import React, { useContext, useRef, useCallback } from 'react'
import useProductSearch from '@@partner:helpers/hooks/useProductSearch'
import useFetchMorePagination from '@@partner:helpers/hooks/useFetchMorePagination'

import { ProductSearchContext } from './ProductSearchContext'
import AppLoader from '@components/common/AppLoader'
import ProductSearchItemWidget from './ProductSearchItemWidget'
import ProductSearchError from './ProductSearchError'
import PreviouslyOrderedProducts from './PreviouslyOrderedProducts'
// TODO: maybe needs replace with another scroller
import InfiniteScroll from 'react-infinite-scroller/dist/InfiniteScroll'

import { SEARCH_QUERY_MIN_LENGTH } from '@@partner:config/index'
import {
  SEARCH_ERROR_NO_QUERY,
  SEARCH_ERROR_NO_RESULT
} from './ProductSearchError'

import './ProductSearchResult.scss'

export interface ProductSearchResultProps {
  onProductClick(id: GQL_ID, amount: number): void
  // onDeleteProduct(id: GQL_ID): void
}

export default function ProductSearchResult ({
  onProductClick
}: // onDeleteProduct
ProductSearchResultProps) {
  const loadMoreRefParent = useRef<HTMLDivElement>(null)
  const { currentShopID, customerID, filter } = useContext(ProductSearchContext)
  const { products, loading, fetchMore } = useProductSearch(
    currentShopID,
    filter
  )

  const updaterFunction = useCallback((cached: any, fetched: any) => {
    const prev = cached?.searchProducts?.edges ?? []
    const curr = fetched?.searchProducts?.edges ?? []

    return {
      hasMore: curr.length > 0,
      result: {
        searchProducts: {
          ...fetched.searchProducts,
          edges: [ ...prev, ...curr ]
        }
      }
    }
  }, [])

  const { hasMore, loadingMore, fetchNextPage } = useFetchMorePagination(
    {
      fetchMore,
      updaterFunction
    },
    [ filter ]
  )

  if (loading) {
    return <AppLoader.Inline />
  }

  const errNoQuery = filter.name.length < SEARCH_QUERY_MIN_LENGTH
  const errNoResults = products.length === 0
  const noErrors = !errNoResults && !errNoQuery
  const isInitialLoading = loading && !loadingMore
  const errType = errNoQuery ? SEARCH_ERROR_NO_QUERY : SEARCH_ERROR_NO_RESULT

  return (
    <div className="ProductSearchResult" ref={loadMoreRefParent}>
      {isInitialLoading && (
        <div className="ProductSearchResult__Loading">
          <AppLoader.Inline center size="md" />
        </div>
      )}

      {noErrors ? (
        <InfiniteScroll
          className="ProductSearchResult__Items"
          loadMore={fetchNextPage}
          hasMore={hasMore}
          useWindow={false}
          initialLoad={false}
          getScrollParent={() => loadMoreRefParent.current}
          // loader={<AppLoader.RowsWithText content="Загрузка" />}
        >
          {products.map((product: any) => (
            <ProductSearchItemWidget
              key={product.id}
              product={product}
              onProductChoose={onProductClick}
            />
          ))}
        </InfiniteScroll>
      ) : (
        <div className="ProductSearchResult__Error">
          <ProductSearchError error={errType} />

          {customerID && currentShopID && (
            <PreviouslyOrderedProducts
              shop_id={currentShopID}
              customer_id={customerID}
              scrollParentRef={loadMoreRefParent}
              onProductChoose={onProductClick}
            />
          )}
        </div>
      )}
    </div>
  )
}
